import { api } from './client';
import { detectBlockchainInput } from '../explorer/detectInput';

export { detectBlockchainInput };

export async function detectExplorerQuery(query) {
  const { data } = await api.get('/v1/explorer/detect', { params: { q: query } });
  return data;
}

export async function searchExplorer(query) {
  const { data } = await api.get('/v1/explorer/search', { params: { q: query } });
  return data;
}
